import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { isBrowser } from '@jelly/utils';
/**
 * Custom hook checking if user scrolled past a pixel mark vertically
 * @function usePastScrollYMark
 * @param {number} YScrollMark - number scroll mark, if past it return true, else false
 */

export var usePastScrollYMark = function usePastScrollYMark(YScrollMark) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isPastY = _useState2[0],
      setScrollY = _useState2[1];

  useEffect(function () {
    if (!isBrowser()) {
      return false;
    }

    var handleScroll = function handleScroll() {
      return setScrollY(window.pageYOffset >= YScrollMark);
    };

    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  });
  return isPastY;
};
export default usePastScrollYMark;